/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'profile': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M45 46.21c0 1.534-1.272 2.79-2.848 2.79H7.848C6.281 49 5 47.749 5 46.21c0-10.789 8.955-19.536 20-19.536 11.044 0 20 8.747 20 19.535zM25 30.022c-8.96 0-16.259 6.947-16.562 15.628h33.124C41.26 36.97 33.96 30.023 25 30.023zm0-5.581c-6.63 0-12-5.246-12-11.721S18.37 1 25 1s12 5.246 12 11.72c0 6.476-5.37 11.722-12 11.722zm0-3.349c4.732 0 8.572-3.75 8.572-8.372S29.732 4.349 25 4.349c-4.732 0-8.571 3.75-8.571 8.372s3.84 8.372 8.571 8.372z" _fill="#AAB2BD" fill-rule="evenodd"/>'
  }
})
